exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Attachment_container_33Fq {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.Attachment_download_2K_k {\n  -webkit-box-flex: 0;\n  -webkit-flex: 0 0 16%;\n      -ms-flex: 0 0 16%;\n          flex: 0 0 16%;\n}\n\n.Attachment_attachmentIcon_MNub {\n  margin: 0 5px;\n\n  width: 22px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "Attachment_container_33Fq",
	"download": "Attachment_download_2K_k",
	"attachmentIcon": "Attachment_attachmentIcon_MNub"
};